import { Component, Input, OnInit, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { PaymentExposedService } from '../../data-access/payment-exposed.service';
import { AmountPipe } from '../../../payments/payment/pipes/amount.pipe';
import { CommonModule } from '@angular/common';
import { TimestampPipe } from '../../../payments/payment/pipes/timestamp.pipe';
import { CartStatusComponent } from '../../ui/cart-status/cart-status.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CartDetailsDialogComponent } from '../../ui/cart-details-dialog/cart-details-dialog.component';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatIcon,
    AmountPipe,
    CommonModule,
    TimestampPipe,
    CartStatusComponent,
    MatDialogModule,
    MatButton
  ],
  providers: [
    PaymentExposedService
  ],
  selector: 'equine-ui-nx-cart-list',
  templateUrl: './cart-list.component.html',
  styleUrls: ['./cart-list.component.scss']
})
export class CartListComponent implements OnInit {

  private paymentExposedService = inject(PaymentExposedService);
  public dialog = inject(MatDialog);
  private router = inject(Router);


  @Input({ required: true }) userId!: string;

  cartTable = [];
  displayedColumns = ['action', 'id', 'type', 'authStatus', 'status', 'date', 'total'];

  totalLines = 0;
  pageSizeOptions: number[] = [10, 20, 50];
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.fetchTableData();
  }

  fetchTableData() {
    this.paymentExposedService.getCartsTable(this.userId, this.pageSize, this.pageIndex)
      .subscribe({
        next: (response: any) => {
          this.totalLines = response?.metadata?.count;
          this.cartTable = response?.data;

        }
      })
  }

  onPaginationChange(paginationChange: any) {
    console.log(paginationChange)
    this.pageSize = paginationChange.pageSize;
    this.pageIndex = paginationChange.pageIndex;

    this.fetchTableData();
  }

  openDetailsDialog(id: string) {
    this.paymentExposedService.getCartDetailsByCartId(id)
      .subscribe({
        next: (response) => {
          this.dialog.open(CartDetailsDialogComponent, {
            data: response
          })
        }
      });
  }

  goToCart() {
    this.router.navigate(['payments', 'payment-summary']);
  }

}
